"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * reef REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MoveEventToJSON = exports.MoveEventFromJSONTyped = exports.MoveEventFromJSON = void 0;
const _1 = require("./");
function MoveEventFromJSON(json) {
    return MoveEventFromJSONTyped(json, false);
}
exports.MoveEventFromJSON = MoveEventFromJSON;
function MoveEventFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'from': _1.XYZCoordFromJSON(json['from']),
        'to': _1.XYZCoordFromJSON(json['to']),
    };
}
exports.MoveEventFromJSONTyped = MoveEventFromJSONTyped;
function MoveEventToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'from': _1.XYZCoordToJSON(value.from),
        'to': _1.XYZCoordToJSON(value.to),
    };
}
exports.MoveEventToJSON = MoveEventToJSON;
